import { LoaderFunctionArgs, useLoaderData, useOutletContext } from "react-router";
import { createProfileTagURL } from "#lib/urls";
import { PageSkeleton } from "#components/pages";
import { paysites } from "#entities/paysites";
import { fetchProfileTags, Tag } from "#api/tags";
import { OutletContext } from "./creator-page";

interface IProps {
  tags: Tag[];
}

export function ProfileTagsPage() {
  const { tags } = useLoaderData() as IProps;
  const { creator }: OutletContext = useOutletContext();
  const paysite = paysites[creator.service];
  const title = `Tags of "${creator.name}" from ${paysite.title}`;

  return (
    <PageSkeleton name="user" title={title}>
      <section id="tag-container">
        {tags.length === 0 ? (
          <div className="no-results">
            <h2 className="site-section__subheading">
              Nobody here but us chickens!
            </h2>
            <p className="subtitle">There are no tags for your query.</p>
          </div>
        ) : (
          tags.map((tag, index) => (
            <article key={tag.tag}>
              <a
                key={index}
                href={String(createProfileTagURL(creator.service, creator.id, tag.tag))}
              >
                <span>{tag.tag}</span>
                <span>{tag.post_count}</span>
              </a>
            </article>
          ))
        )}
      </section>
    </PageSkeleton>
  );
}

export async function loader({ params }: LoaderFunctionArgs): Promise<IProps> {
  const service = params.service!.trim();
  const creatorId = params.creatorId!.trim();

  const tags = fetchProfileTags(service, creatorId);

  return { tags: await tags };
}
